import loadable from '@loadable/component';

import { createPlugin } from '@backstage/core-plugin-api';

import { ExperimentIcon } from '@spotify/confidence-core-react';
import { AdminV1AccountMode } from '@spotify/confidence-graphql';
import {
  createTreatmentsChangeExtension,
  createWorkflowExtension,
} from '@spotify/plugin-confidence-workflows-react';

import { ReanalysisTableRow } from './components';
import {
  EXPOSURE_KEY_CHANGE_EXTENSION,
  HYPOTHESIS_CHANGE_EXTENSION,
  REANALYSIS_CONFIG_CHANGE_EXTENSION,
  REANALYSIS_CONFIG_SUPPRESS_EXTENSION,
} from './components/ReanalysisInstanceUpdates';
import { REANALYSIS_WORKFLOW_ID } from './constants';

const REANALYSIS_TREATMENTS_CHANGE_EXTENSION = createTreatmentsChangeExtension({
  id: 'reanalysis-treatments-change',
  fieldPath: '/module_data/reanalysis',
});

export const confidenceWorkflowsModuleReanalysisPlugin = createPlugin({
  id: 'confidence-workflows-module-reanalysis',
});

const componentsChunk = () =>
  import(
    /* webpackChunkName: "workflows-analysis-pages", webpackPrefetch: 5 */ './components'
  );
const loadOptions = {};

const ReanalysisWorkflowPage = loadable(
  () => componentsChunk().then(m => m.ReanalysisWorkflowPage),
  loadOptions,
);
const ReanalysisWorkflowInstancePage = loadable(
  () => componentsChunk().then(m => m.ReanalysisWorkflowInstancePage),
  loadOptions,
);
const CreateReanalysis = loadable(
  () => componentsChunk().then(m => m.CreateReanalysis),
  loadOptions,
);

// Change extensions

export const ExposureKeyChangeExtension =
  confidenceWorkflowsModuleReanalysisPlugin.provide(
    EXPOSURE_KEY_CHANGE_EXTENSION,
  );

export const HypothesisChangeExtension =
  confidenceWorkflowsModuleReanalysisPlugin.provide(
    HYPOTHESIS_CHANGE_EXTENSION,
  );

export const ReanalysisConfigSuppressExtension =
  confidenceWorkflowsModuleReanalysisPlugin.provide(
    REANALYSIS_CONFIG_SUPPRESS_EXTENSION,
  );

export const ReanalysisConfigChangeExtension =
  confidenceWorkflowsModuleReanalysisPlugin.provide(
    REANALYSIS_CONFIG_CHANGE_EXTENSION,
  );

export const ReanalysisTreatmentsChangeExtension =
  confidenceWorkflowsModuleReanalysisPlugin.provide(
    REANALYSIS_TREATMENTS_CHANGE_EXTENSION,
  );

export const ReanalysisWorkflowExtension =
  confidenceWorkflowsModuleReanalysisPlugin.provide(
    createWorkflowExtension({
      title: 'Analysis',
      description: 'Analyze data without running an experiment',
      workflowId: REANALYSIS_WORKFLOW_ID,
      workflowPage: () => <ReanalysisWorkflowPage />,
      workflowInstancePage: () => <ReanalysisWorkflowInstancePage />,
      workflowTableRowComponent: ReanalysisTableRow,
      workflowIcon: ExperimentIcon,
      createDialog: CreateReanalysis,
      notCreatableInAccountModes: [AdminV1AccountMode.TotalConfidence],
    }),
  );
